// API END Points
import * as constants from "../utils/constants";
/**---------------Authentication------------------------------ */
export const AUTH = {
  REGISTER: "vendor" + " " + constants.POST_RAW,
  LOGIN: "vendor/login" + " " + constants.POST_RAW,
  LOGOUT: "vendor/logout" + " " + constants.POST_RAW,
  RESEND: "vendor/otp/resend" + " " + constants.PATCH,
  VERIFY: "vendor/otp/verify" + " " + constants.POST_URL_ENCODED,
  FORGOTPASSWORD: "vendor/password/forgot" + " " + constants.POST_URL_ENCODED,
  VERIFYPASSWORD:
    "vendor/password/code/verify" + " " + constants.POST_URL_ENCODED,
  RESETPASSWORD: "vendor/password/reset" + " " + constants.POST_URL_ENCODED,
  CHANGEPASSWORD: "vendor/password" + " " + constants.PATCH_URL_ENCODED,
};
export const KYC = {
  KYCINIT: "vendor/kyc/init" + " " + constants.GET_ID_PARAMS,
  KYCUPDATE: "vendor/kyc" + " " + constants.MULTI_PART_ID_PATCH,
  KYCFEEDBACK: "vendor/kyc/feedback" + " " + constants.MULTI_PART_ID_POST,
  KYCREAD: "vendor/kyc/status/read" + " " + constants.PATCH_FORM_ID_URL_ENCODED,
  KYCSTATUSCHECK: "vendor/dashboard/status" + " " + constants.GET,
};
export const BUSINESS = {
  GETPROFILE: "vendor/business/profile" + " " + constants.GET_ID_PARAMS,
  UPDATEPROFILE:
    "vendor/business/profile" + " " + constants.MULTI_PART_ID_PATCH,
  VERIFYDETAILS:
    "vendor/business/otp/profile" + " " + constants.POST_URL_ENCODED_ID_PARAMS,
  UPDATEBANKDETAILS: "vendor/business/bank-details" + " " + constants.PATCH_ID,
  BANKDETAILS: "vendor/business/bank-details" + " " + constants.GET_ID_PARAMS,
  ASSIGNED_CATEGORIES:
    "vendor/business/assigned-categories" + " " + constants.GET_URL_PARAMS,
};
export const DEFAULT = {
  CERTIFICATES:
    "vendor/default/business/certificate" + " " + constants.GET_URL_PARAMS,
  BUSINESSTYPES:
    "vendor/default/business/types" + " " + constants.GET_URL_PARAMS,
  CATEGORIES:
    "vendor/default/business/categories" + " " + constants.GET_URL_PARAMS,
  BRANDS: "vendor/business/brands" + " " + constants.GET_URL_PARAMS,  
  DISTRICTS: "_default/districts" + " " + constants.GET_URL_PARAMS,
  BANKCOUNTER: "_default/default/bank-counter" + " " + constants.GET_URL_PARAMS,
};
export const NOTIFICATION = {
  GETNOTFICATION:
    "vendor/business/notifications" + " " + constants.GET_URL_ID_PARAMS,
  GETNOTFICATIONCOUNT:
    "vendor/business/notifications/count" + " " + constants.GET_ID_PARAMS,
  MARKREAD: "vendor/business/notifications" + " " + constants.POST_ID_PARAMS,
};
export const PRODUCT = {
  initProduct:
    "_product/business-products/init" + " " + constants.GET_URL_PARAMS,
  initVariant:
    "_product/business-products/init/variant" + " " + constants.GET_ID_PARAMS,
  listProduct: "_product/manage/vendor-products/list" + " " + constants.GET_URL_ID_PARAMS,
  draftCount:
    "_product/business-products/draft/count" + " " + constants.GET_ID_PARAMS,
  draftList:
    "_product/business-products/draft" + " " + constants.GET_URL_ID_PARAMS,
  deleteProduct:
    "_product/business-products" + " " + constants.DELETE_ID_PARAMS,
  updateProductState:
    "_product/business-products/state/variant" +
    " " +
    constants.PATCH_FORM_ID_URL_ENCODED,
  productInfo:
    "_product/manage/vendor-products/variant" + " " + constants.GET_ID_PARAMS,
  addProduct: "_product/business-products" + " " + constants.MULTI_PART_ID_POST,
  listVariants:
    "_product/business-products/list-variants" +
    " " +
    constants.GET_URL_ID_PARAMS,
  editProduct:
    "_product/business-products" + " " + constants.PATCH_FORM_ID_URL_ENCODED,
  editProductVariant:
    "_product/business-products/variant" +
    " " +
    constants.PATCH_FORM_ID_URL_ENCODED,
  productExists:
    "_product/business-products/exists" + " " + constants.GET_URL_PARAMS,
};
export const PURCHASEORDER = {
  listPurchaseOrders: "_product/shipments" + " " + constants.GET_URL_ID_PARAMS_WITH_MULTIPLE_STATUS,
  purchaseOrderInfo: "_product/shipments/info" + " " + constants.GET_ID_PARAMS,
  poDownload: "_product/manage/shipments/invoice" + " " + constants.GET_ID_PARAMS,
  grnDownload: "_product/shipments/grn-invoice" + " " + constants.GET_URL_ID_PARAMS,
    updatePurchaseOrderStatus:
    "_product/manage/shipments/status" + " " + constants.PATCH_ID,
  lowStock: "_product/manage/low-stock" + " " + constants.GET_ID_PARAMS,
    productListForPurchaseOrder:
    "_product/vendor-products/list-variants" + " " + constants.GET_URL_PARAMS,
    addPurchaseOrder:
    "_product/manage/shipments" + " " + constants.POST_ID_PARAMS, 
};
export const ADVERTISEMENT = {
  FEES: "_product/advertisements/fees" + " " + constants.GET,
  ADD: "_product/advertisements" + " " + constants.MULTI_PART_ID_POST,
  LIST: "_product/advertisements" + " " + constants.GET_URL_ID_PARAMS,
  PAY: "_product/advertisements/payment" + " " + constants.POST_ID_PARAMS,
  DETAILS: "_product/advertisements/info" + " " + constants.GET_ID_PARAMS,
};
export const inventory = {
  list: "_product/manage/shipments/list" + " " + constants.GET_URL_PARAMS,
  addCostInfo:
    "_product/manage/shipments/cost" + " " + constants.POST_ID_PARAMS,
  sendShipmentRequest:
    "_product/manage/shipments" + " " + constants.POST_ID_PARAMS,
  info: "_product/manage/shipments" + " " + constants.GET_ID_PARAMS,
  infoInventory:
    "_product/manage/shipments/completion-init" + " " + constants.GET_ID_PARAMS,
  updateStatus: "_product/manage/shipments/status" + " " + constants.PATCH_ID,
  listInventoryProduct:
    "_product/manage/vendor-products/inventory/list" +
    " " +
    constants.GET_URL_PARAMS,
  inventoryStats:
    "_product/manage/inventory/stats" + " " + constants.GET_URL_PARAMS,
  listInventoryVarianTransaction:
    "_product/manage/inventory/transactions" +
    " " +
    constants.GET_URL_ID_PARAMS,
  variantStockList:
    "_product/manage/inventory/in-stock" + " " + constants.GET_ID_PARAMS,
  variantUpdateInit:
    "_product/manage/inventory/update-init" + " " + constants.GET_ID_PARAMS,
  variantUpdate: "_product/manage/inventory/update" + " " + constants.PATCH_ID,
  variantExpiredStockInfo:
    "_product/manage/inventory/expiring-stock/info" +
    " " +
    constants.GET_URL_PARAMS,
  variantExpiredStockList:
    "_product/manage/inventory/expiring-stock/list" +
    " " +
    constants.GET_URL_PARAMS,
  variantRemainder:
    "_product/manage/inventory/reminder" +
    " " +
    constants.POST_URL_ENCODED_ID_PARAMS,
  initReceivedDirectGoods:
    "_product/manage/inventory/batches" + " " + constants.GET_ID_PARAMS,
  receivedDirectGoods:
    "_product/manage/inventory/update-multiple" + " " + constants.PATCH_ID,
  addProductToLowStockList:
    "_product/manage/low-stock" + " " + constants.POST_RAW,
  lowStockList: "_product/manage/low-stock" + " " + constants.GET_URL_PARAMS,
  markAsOrdered: "_product/manage/low-stock" + " " + constants.PATCH_ID,
  lowStockReport:
    "_product/manage/low-stock/report" + " " + constants.GET_URL_PARAMS,
  outofstock:
    "_product/manage/inventory/out-of-stock" + " " + constants.GET_URL_PARAMS,
};
export const multipleWarehouse = {
  listWarehouse: "_product/warehouse" + " " + constants.GET_ID_PARAMS,
};
export const payouts = {
  list: "_product/payouts/business" + " " + constants.GET_URL_ID_PARAMS,
  info: "_product/payouts" + " " + constants.GET_ID_PARAMS,
  payoutsCompleted:
    "_product/payouts/shipments/init" + " " + constants.POST_ID_PARAMS,
};
export const ordersDelivery = {
  init: "_product/manage/orders/init" + " " + constants.GET_URL_PARAMS,
  add: "_product/manage/orders" + " " + constants.POST_RAW,
  edit: "_product/manage/orders" + " " + constants.PATCH_ID,
  info: "_product/manage/orders/info" + " " + constants.GET_ID_PARAMS,
  list: "_product/manage/orders/list" + " " + constants.GET_URL_PARAMS,
  listAssistAdmin:
    "_product/manage/orders/assist-admin/list" + " " + constants.GET_URL_PARAMS,
  status:
    "_product/manage/orders/status" + " " + constants.PATCH_FORM_ID_URL_ENCODED,
  variant: "_product/manage/orders/count" + " " + constants.GET_URL_ID_PARAMS,
  variantWithoutBusinessId:
    "_product/manage/orders/count/variant-order" +
    " " +
    constants.GET_URL_ID_PARAMS,
  invoiceDownload:
    "_product/reports/orders/invoice" + " " + constants.GET_ID_PARAMS,
  markAsDelivered:
    "_product/manage/orders/mark-as-completed" +
    " " +
    constants.PATCH_FORM_ID_URL_ENCODED,
  checkStock: "_product/manage/orders/check-stock" + " " + constants.POST_RAW,
  checkStatus:
    "_product/manage/orders/check-status" + " " + constants.GET_ID_PARAMS,
  pendingDeliveryOrder:
    "_product/manage/orders/send-delivery-message" + " " + constants.POST_RAW,
};
export const dashboard = {
  dashboard: "vendor/dashboard" + " " + constants.POST_RAW,
  salesReport: "vendor/sales-report" + " " + constants.POST_RAW,
  brandPerformance: "vendor/brand-performance" + " " + constants.GET_URL_PARAMS,
  categoryPerformance: "vendor/category-performance" + " " + constants.POST_RAW,
  orderReport: "_product/shipments/shipment-report" + " " + constants.GET_URL_ID_PARAMS,
  topVendors: "vendor/top-vendors" + " " + constants.GET_URL_PARAMS,
  lowStockProducts: "vendor/low-stock-products" + " " + constants.GET_URL_PARAMS,  
  topSellingProducts: "vendor/top-selling-products" + " " + constants.GET_URL_PARAMS,
  achievements: "vendor/achievements" + " " + constants.GET_URL_PARAMS,
};

export const interTransferRequest = {
  interTransferList:
    "_product/business-stock-transfer-request/list" +
    " " +
    constants.GET_URL_ID_PARAMS,
  transferDetail:
    "_product/business-stock-transfer-request/info" +
    " " +
    constants.GET_IDS_PARAMS,
};

export const seller = {
  kycDetails: "business/list" + " " + constants.GET_URL_PARAMS,
  checkCategories:
    "business/check-categories" + " " + constants.GET_URL_ID_PARAMS,
  sellerProfile: "business/profile" + " " + constants.GET_ID_PARAMS,
  kycStatusUpdate:
    "business/kyc/status" + " " + constants.PATCH_FORM_ID_URL_ENCODED,
  sellerProfileUpdate: "business/profile" + " " + constants.MULTI_PART_ID_PATCH,
  profileUpdateLogs:
    "business/update-logs/profile" + " " + constants.GET_ID_PARAMS,
  listSeller: "seller/manage-business/list" + " " + constants.GET_URL_PARAMS,
  updateSellerState:
    "seller/manage-business/account-state" +
    " " +
    constants.PATCH_FORM_ID_URL_ENCODED,
  addSeller: "seller/manage-business/add" + " " + constants.POST_FORM,
  listSellerProduct:
    "_product/manage/business-products/list" +
    " " +
    constants.GET_URL_ID_PARAMS,
  listSellableProduct:
    "_product/manage/business-products/sellable" +
    " " +
    constants.GET_URL_PARAMS,
  sellableProductInfo:
    "_product/manage/business-products/info" + " " + constants.GET_ID_PARAMS,
  listInventory:
    "_product/manage/vendor-products/inventory/list" +
    " " +
    constants.GET_URL_PARAMS,
  listInventoryHistory:
    "_product/manage/inventory/business/transactions" +
    " " +
    constants.GET_URL_ID_PARAMS,
  listStockDetails:
    "_product/manage/inventory/business/in-stock" +
    " " +
    constants.GET_URL_ID_PARAMS,
  listOrder: "_product/manage/orders/list" + " " + constants.GET_URL_ID_PARAMS,
  listAdvertisement:
    "_product/manage/advertisements" + " " + constants.GET_URL_ID_PARAMS,
  listGoodsRequest:
    "_product/manage/shipments/list" + " " + constants.GET_URL_ID_PARAMS,
  payoutProfiles: "business/payout-profiles" + " " + constants.GET_URL_PARAMS,
  payoutOrderList:
    "_product/manage/shipments/vendors/payouts/business-orders" +
    " " +
    constants.GET_URL_ID_PARAMS,
  payoutInfo: "_product/manage/orders/payouts" + " " + constants.GET_ID_PARAMS,
  payoutList:
    "_product/manage/orders/payouts/business" +
    " " +
    constants.GET_URL_ID_PARAMS,
  payout:
    "_product/manage/orders/payouts/business" + " " + constants.POST_ID_PARAMS,
  orderSales:
    "_product/manage/orders/sales-report" + " " + constants.GET_URL_PARAMS,
  orderSalesReport:
    "_product/reports/order-sales" + " " + constants.GET_URL_PARAMS,
  orderSalesReportV2:
    "_product/reports/order-sales-v2" + " " + constants.GET_URL_PARAMS,
  orderSalesReportV3:
    "_product/reports/order-sales-v3" + " " + constants.GET_URL_PARAMS,
  orderSalesReportV4:
    "_product/reports/order-sales-v4" + " " + constants.GET_URL_PARAMS,
  orderSalesReportV5:
    "_product/reports/order-sales-v5" + " " + constants.GET_URL_PARAMS,
  orderSalesReportV6:
    "_product/reports/order-sales-v6" + " " + constants.GET_URL_PARAMS,
  orderSalesReportV7:
    "_product/reports/order-sales-v7" + " " + constants.GET_URL_PARAMS,
  orderSalesReportV8:
    "_product/reports/order-sales-v8" + " " + constants.GET_URL_PARAMS,
  returnProductReport:
    "_product/reports/return-product" + " " + constants.GET_URL_PARAMS,
  orderDelivered:
    "_product/manage/orders/list-delivered" + " " + constants.GET_URL_PARAMS,
  financeBankList: "admin/finance-bank" + " " + constants.GET_URL_PARAMS,
  financeSalesReport:
    "_product/manage/orders/finance-stats" + " " + constants.GET_URL_PARAMS,
  updateFinanceDetails:
    "_product/manage/orders/finance-details" + " " + constants.PATCH_ID,
};

export const reports = {
  sellerPayout: "_product/reports/business-payouts" + " " + constants.POST_RAW,
  sellerReport:
    "_product/reports/orders-businesses" + " " + constants.GET_URL_PARAMS,
  customerReport:
    "_product/reports/orders-customers" + " " + constants.GET_URL_PARAMS,
  productsReport:
    "_product/reports/business-products" + " " + constants.GET_URL_PARAMS,
  productsPriceListReport:
    "_product/reports/business-products-price-list" +
    " " +
    constants.GET_URL_PARAMS,
  productVariantReport:
    "_product/reports/products-variants" + " " + constants.GET_URL_PARAMS,
  dashboardReport: "_product/reports/sales" + " " + constants.GET_URL_PARAMS,
  inventoryReport:
    "_product/reports/inventory" + " " + constants.GET_URL_PARAMS,
  customerRegistrationReport:
    "_product/reports/buyer-registration" + " " + constants.GET_URL_PARAMS,
  purchaseBehaviourReport:
    "_product/analytics/purchase-behaviour" + " " + constants.GET_URL_PARAMS,
  geographicSalesReport:
    "_product/analytics/geographic-sales-insight" +
    " " +
    constants.GET_URL_PARAMS,
  areaBasedCustomerReport:
    "_product/analytics/area-based-customer-segmentation" +
    " " +
    constants.GET_URL_PARAMS,
  frequentCustomerReport:
    "_product/analytics/frequent-customer-purchase-pattern-analysis" +
    " " +
    constants.GET_URL_PARAMS,
  productSalesPerformaceReport:
    "_product/analytics/product-sales-performance" +
    " " +
    constants.GET_URL_PARAMS,
  brandWiseSalesReport:
    "_product/analytics/brand-wise-sales-performance" +
    " " +
    constants.GET_URL_PARAMS,
  categorySubCategoryReport:
    "_product/analytics/category-sub-category-sales-analysis" +
    " " +
    constants.GET_URL_PARAMS,
  revenueGenerationReport:
    "_product/analytics/revenue-generation" + " " + constants.GET_URL_PARAMS,
  commissionAnalysisReport:
    "_product/analytics/commission-generation" + " " + constants.GET_URL_PARAMS,
  productVariantInventoryReport:
    "_product/analytics/product-variant-inventory-status" +
    " " +
    constants.GET_URL_PARAMS,
};

export const vendor = {
  listVendor: "vendor/manage-business/list" + " " + constants.GET_URL_PARAMS,
  addVendor: "vendor/manage-business/add" + " " + constants.POST_FORM,
  vendorProfile: "business/profile" + " " + constants.GET_ID_PARAMS,
  vendorProfileUpdate: "business/profile" + " " + constants.MULTI_PART_ID_PATCH,
  listVendorProduct:
    "_product/vendor-products/list" + " " + constants.GET_URL_ID_PARAMS,
  bankDetails: "vendor/manage-business/bank-details" + " " + constants.GET_ID_PARAMS,
};

export const master = {
  // Primary category
  addCategory: "business/categories" + " " + constants.POST_FORM,
  editCategory: "business/categories" + " " + constants.MULTI_PART_ID_PATCH,
  deleteCategory: "business/categories" + " " + constants.DELETE_ID_PARAMS,
  categoryList: "vendor/default/business/categories" + " " + constants.GET_URL_PARAMS,
  // Sub category
  addSubCategory: "business/categories/sub" + " " + constants.POST_FORM,
  editSubCategory:
    "business/categories/sub" + " " + constants.MULTI_PART_ID_PATCH,
  deleteSubCategory:
    "business/categories/sub" + " " + constants.MULTI_PART_ID_DELETE,
  // Group category
  addGroupCategory: "business/categories/group" + " " + constants.POST_FORM,
  editGroupCategory:
    "business/categories/group" + " " + constants.MULTI_PART_ID_PATCH,
  deleteGroupCategory:
    "business/categories/group" + " " + constants.MULTI_PART_ID_DELETE,
  // Business ceritificates
  addCertificate: "business/config/certificate" + " " + constants.POST_FORM,
  listCertificate:
    "business/config/certificate" + " " + constants.GET_URL_PARAMS,
  editCertificate:
    "business/config/certificate" + " " + constants.MULTI_PART_ID_PATCH,
  deleteCertificate:
    "business/config/certificate" + " " + constants.DELETE_ID_PARAMS,
  // Business types
  addBusinessTypes: "business/types" + " " + constants.POST_FORM,
  editBusinessTypes: "business/types" + " " + constants.MULTI_PART_ID_PATCH,
  deleteBusinessTypes: "business/types" + " " + constants.DELETE_ID_PARAMS,
  listBusinessTypes: "business/types" + " " + constants.GET_URL_PARAMS,
  // Brands
  addBrands: "_product/default/brands" + " " + constants.POST_FORM,
  editBrands: "_product/default/brands" + " " + constants.MULTI_PART_ID_PATCH,
  deleteBrands: "_product/default/brands" + " " + constants.DELETE_ID_PARAMS,
  listBrands: "_product/default/brands" + " " + constants.GET_URL_PARAMS,
  //Technical Details
  technicalCategories:
    "_product/default/technical-detail-fields/categories" + " " + constants.GET,
  technicalDetailFeild:
    "_product/default/technical-detail-fields/categories" +
    " " +
    constants.GET_ID_PARAMS,
  addTechnicalDetails:
    "_product/default/technical-detail-fields" + " " + constants.POST_RAW,
  editTechnicalDetails:
    "_product/default/technical-detail-fields" + " " + constants.PATCH_ID,
  deleteTechnicalDetails:
    "_product/default/technical-detail-fields" +
    " " +
    constants.DELETE_ID_PARAMS,
  //Product Variants
  variantTiles: "_product/default/variants" + " " + constants.GET_URL_PARAMS,
  addVariants: "_product/default/variants" + " " + constants.POST_RAW,
  editVariants: "_product/default/variants" + " " + constants.PATCH_ID,
  deleteVariants:
    "_product/default/variants" + " " + constants.DELETE_ID_PARAMS,
  deleteSubVariants:
    "_product/default/variants" + " " + constants.MULTI_PART_ID_DELETE,
  variantInfo: "_product/default/variants" + " " + constants.GET_URL_ID_PARAMS,
  addArea: "business/loading-areas" + " " + constants.POST_FORM,
  listArea: "business/loading-areas" + " " + constants.GET_URL_PARAMS,
  editArea:
    "business/loading-areas" + " " + constants.PATCH_FORM_ID_URL_ENCODED,
  info: "business/loading-areas" + " " + constants.GET_ID_PARAMS,
  updateAreaStatus: "business/loading-areas/status" + " " + constants.PATCH_ID,
  assignLoadingArea: "business/assign-loading-areas" + " " + constants.POST_RAW,
  // roles and permission
  addRoles: "config/role" + " " + constants.POST_RAW,
  getRoles: "config/role" + " " + constants.GET_URL_PARAMS,
  getRoleDetails: "config/role" + " " + constants.GET_ID_PARAMS,
  editDetails: "config/role" + " " + constants.PATCH_ID,
  deleteRole: "config/role" + " " + constants.DELETE_ID_PARAMS,
  // user management
  addUser: "user-management" + " " + constants.POST_FORM,
  getUsers: "user-management" + " " + constants.GET_URL_PARAMS,
  updateUserStatus: "user-management/status" + " " + constants.PATCH_ID,
  deleteUser: "user-management" + " " + constants.DELETE_ID_PARAMS,
  getUserDetails: "user-management" + " " + constants.GET_ID_PARAMS,
  editUserDetails: "user-management" + " " + constants.PATCH_FORM_ID,

  // city master
  addCity: "_default/city" + " " + constants.POST_RAW,
  listCity: "_default/list-cities" + " " + constants.GET_URL_PARAMS,
  editCity: "_default/city" + " " + constants.PATCH_ID,
  listCityAndDistrict:
    "_default/city-with-districts" + " " + constants.GET_URL_PARAMS,
  // district master
  addDistrict: "_default/districts" + " " + constants.POST_RAW,
  listDistricts: "_default/districts" + " " + constants.GET_URL_PARAMS,
  editDistrict: "_default/districts" + " " + constants.PATCH_ID,
};

export const product = {
  initProduct: "_product/init" + " " + constants.GET_URL_PARAMS,
  listProduct: "_product/list" + " " + constants.GET_URL_PARAMS,
  draftCount:
    "_product/default/product-templates/draft/count" + " " + constants.GET,
  draftList:
    "_product/default/product-templates/draft" + " " + constants.GET_URL_PARAMS,
  deleteProduct:
    "_product/default/product-templates" + " " + constants.DELETE_ID_PARAMS,
  updateProductState:
    "_product/default/product-templates/state/variant" +
    " " +
    constants.PATCH_FORM_ID_URL_ENCODED,
  productInfo: "_product/variant" + " " + constants.GET_ID_PARAMS,
  addProduct: "_product/product" + " " + constants.POST_FORM,
  initProductVariant: "_product/init/variant" + " " + constants.GET_ID_PARAMS,
  editProduct: "_product/product" + " " + constants.PATCH_FORM_ID_URL_ENCODED,
  editProductVariant:
    "_product/variant" + " " + constants.PATCH_FORM_ID_URL_ENCODED,
  deleteProductVariant:
    "_product/default/product-templates" + " " + constants.MULTI_PART_ID_DELETE,
  updateSearchTags:
    "_product/default/product-templates/search-tag" + " " + constants.PATCH_ID,
};
export const manageProduct = {
  listProduct:
    "_product/manage/business-products/list" + " " + constants.GET_URL_PARAMS,
  updateVariantStatus:
    "_product/variant" +
    " " +
    constants.PATCH_FORM_ID_URL_ENCODED,
  listVariant:
    "_product/manage/vendor-products/list-variants" +
    " " +
    constants.GET_URL_PARAMS,
  updateSearchTags:
    "_product/search-tag" + " " + constants.PATCH_ID,
  setOrderLimit:
    "_product/manage/vendor-products/set-variant-order-limit" +
    " " +
    constants.PATCH_ID,

  listProductForAssign: "_product/list" + " " + constants.GET_URL_PARAMS,
  assignProductToVendor:
    "_product/manage/assign-product-to-vendor" + " " + constants.POST_RAW,
  unassignProductToVendor:
    "_product/manage/unassign-vendor-from-product" + " " + constants.POST_RAW,
  shipmentTracking:
    "_product/shipment-tracking" + " " + constants.GET_URL_PARAMS,
};
export const poManagementEndPoints = {
  genarateGrn:
    "_product/manage/shipments/status" + " " + constants.PATCH_FORM_ID_V2,
};
export const ESCALATIONS = {
  addEscalation: "_product/escalations" + " " + constants.POST_FORM,
  listEscalation: "_product/escalations" + " " + constants.GET_URL_PARAMS,
  escalationInfo: "_product/escalations" + " " + constants.GET_ID_PARAMS,
};